import { render, staticRenderFns } from "./ClientEmailsTable.vue?vue&type=template&id=47c3f19c&scoped=true&"
import script from "./ClientEmailsTable.vue?vue&type=script&lang=js&"
export * from "./ClientEmailsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c3f19c",
  null
  
)

export default component.exports